<template>
    <div>
        <div class="menus_wrap">
            <div class="menus_head">
                <img src="../../assets/img/menus/logo.png" />
            </div>

            <div class="menus_list">
                <div class="menus_items" :class="meunsId == '1' ? 'menus_items_active' : ''" @click.stop="onCheckItem('1')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '1'">
                                <img class="menus_iicon01" src="../../assets/img/menus/icon01_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon01" src="../../assets/img/menus/icon01.png" />
                            </template>
                        </div>
                        <div class="menus_itext">Mi pedido</div>
                    </div>
                </div>
                <div class="menus_items" :class="meunsId == '2' ? 'menus_items_active' : ''" @click.stop="onCheckItem('2')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '2'">
                                <img class="menus_iicon02" src="../../assets/img/menus/icon02_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon02" src="../../assets/img/menus/icon02.png" />
                            </template>
                        </div>
                        <div class="menus_itext">Aviso de privacidad</div>
                    </div>
                </div>
                <div class="menus_items" :class="meunsId == '3' ? 'menus_items_active' : ''" @click.stop="onCheckItem('3')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '3'">
                                <img class="menus_iicon04" src="../../assets/img/menus/icon04_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon04" src="../../assets/img/menus/icon04.png" />
                            </template>
                        </div>
                        <div class="menus_itext">Términos y condiciones</div>
                    </div>
                </div>

                <!--<div class="menus_items" :class="meunsId == '4' ? 'menus_items_active' : ''" @click.stop="onCheckItem('4')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '4'">
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03.png" />
                            </template>
                        </div>
                        <div class="menus_itext">工作信息</div>
                    </div>
                </div>

                <div class="menus_items" :class="meunsId == '5' ? 'menus_items_active' : ''" @click.stop="onCheckItem('5')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '5'">
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03.png" />
                            </template>
                        </div>
                        <div class="menus_itext">个人信息</div>
                    </div>
                </div>

                <div class="menus_items" :class="meunsId == '6' ? 'menus_items_active' : ''" @click.stop="onCheckItem('6')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '6'">
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03.png" />
                            </template>
                        </div>
                        <div class="menus_itext">联系人</div>
                    </div>
                </div>

                <div class="menus_items" :class="meunsId == '7' ? 'menus_items_active' : ''" @click.stop="onCheckItem('7')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '7'">
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03.png" />
                            </template>
                        </div>
                        <div class="menus_itext">身份证</div>
                    </div>
                </div>

                <div class="menus_items" :class="meunsId == '8' ? 'menus_items_active' : ''" @click.stop="onCheckItem('8')">
                    <div class="menus_item">
                        <div class="menus_iicon">
                            <template v-if="meunsId == '8'">
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03_active.png" />
                            </template>
                            <template v-else>
                                <img class="menus_iicon03" src="../../assets/img/menus/icon03.png" />
                            </template>
                        </div>
                        <div class="menus_itext">银行卡</div>
                    </div>
                </div>-->

            </div>

            <div class="cuenta_footer_view">
                <div class="cuenta_footer">
                    <van-button round hairline color="#999999" plain block style="height: 0.972222rem"  @click.stop="onLoginOut">
                        <span style="font-size: 0.444444rem; font-weight: 500; color: #999999;">Cerrar sesión</span>
                    </van-button>
                </div>
            </div>

            <div class="menus_cview"></div>

        </div>

        <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken, setAccessToken } from '@/utils/auth';

    import { authLogout } from '@/api/login'

    import { Toast } from 'vant';
    export default {
        data() {
            return {
                tabactive: 1,
                meunsId: null,
            }
        },
        mounted() {

        },
        methods: {
            async onLoginOut() {
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    authLogout(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                this.$store.commit('common/SET_PRODUCT_ID', '');
                                localStorage.removeItem('adjust_id');
                                this.$router.replace({
                                    path: '/loanpage/index'
                                })
                            }
                        } else {
                            this.$store.commit('common/SET_PRODUCT_ID', '');
                            localStorage.removeItem('adjust_id');
                            this.$router.replace({
                                path: '/loanpage/index'
                            })
                            //Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });


                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/index'
                    })
                }


            },
            onTabChange(item) {
                //this.tabactive = item;
                if(item == 0){
                    /*this.$router.push({
                        path: '/loanpage/index'
                    })*/
                    this.$router.back();
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            onCheckItem(id){
                this.meunsId = id;
                if(id == '1'){
                    this.$router.push({
                        path: '/loanpage/orderlist'
                    })
                } else if(id == '2'){
                    this.$router.push({
                        path: '/loanpage/privacidad'
                    })
                } else if(id == '3'){
                    this.$router.push({
                        path: '/loanpage/provision'
                    })
                } else if(id == '4'){
                    this.$router.push({
                        path: '/loanpage/applywork'
                    })
                } else if(id == '5'){
                    this.$router.push({
                        path: '/loanpage/applyperson'
                    })
                } else if(id == '6'){
                    this.$router.push({
                        path: '/loanpage/applycontacts'
                    })
                } else if(id == '7'){
                    this.$router.push({
                        path: '/loanpage/applyidcard'
                    })
                } else if(id == '8'){
                    this.$router.push({
                        path: '/loanpage/applybank'
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .menus_wrap{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .menus_head{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0 1.055556rem 0.694444rem;
    }
    .menus_head img{
        display: block;
        width: 1.388889rem;
        height: 1.388889rem;
    }
    .menus_footer{
        width: 100%;
        height: 2.2rem;
        background: #F6F6F6;
        border-radius: 0px 0px 0px 0.555556rem;
        position: absolute;
        left: 0;
        bottom: 0;
        box-sizing: border-box;
        padding: 0.555556rem 0 0 0.694444rem;
        display: flex;
        justify-content: flex-start;
    }
    .menus_ficon{
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ficon img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ftext{
        width: 1.388889rem;
        height: 0.555556rem;
        margin-left: 0.361111rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #666666;
        line-height: 0.555556rem;
    }
    .menus_list{
        width: 100%;
        height: auto;
    }
    .menus_items{
        width: 100%;
        height: 1.305556rem;
    }
    .menus_item{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        padding-left: 0.694444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .menus_iicon{
        width: 0.916667rem;
        height: 0.555556rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-right: 0.361111rem;
    }
    .menus_iicon01{
        display: block;
        width: 0.555556rem;
        height: 0.5rem;
    }
    .menus_iicon02{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon03{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon04{
        display: block;
        width: 0.5rem;
        height: 0.555556rem;
    }
    .menus_itext{
        width: auto;
        height: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.555556rem;
    }
    .menus_cview{
        width: 100%;
        height: 1.861111rem;
    }
    .menus_items_active .menus_item{
        background: #19A95C;
    }
    .menus_items_active .menus_itext{
        color: #FFFFFF;
    }
    .cuenta_footer_view{
        width: 100%;
        height: 0.972222rem;
        position: absolute;
        left: 0;
        bottom: 4.2rem;
    }
    .cuenta_footer{
        width: 3.611111rem;
        height: 0.972222rem;
        margin: auto;
    }
</style>